import { Divider, MenuItem } from "@mui/material";
import CircleRoundedIcon from "@mui/icons-material/CircleRounded";
// import DeleteOutlineRoundedIcon from "@mui/icons-material/DeleteOutlineRounded";
// import { actions } from "../../../../app/appSlice";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ROLE } from "../../../../../utils/constants/profiles";
import {
  typeNotificationIcon,
  typeNotificationIconUser,
} from "../../../../../typeNotifications";
import { useReadNotificationMutation } from "../../../../../features/api/user/notificationUserApi";
import { useReadNotificationAdminMutation } from "../../../../../features/api/admin/notificationAdmin";

const ListsNotification = ({ lists, setAnchorElNotifiche }) => {
  const role = useSelector((state) => state.app.role);
  const primaryColor = useSelector((state) => state.app.primaryColor);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [readNotification] = useReadNotificationMutation();
  const [readNotificationAdmin] = useReadNotificationAdminMutation();

  const handleRouteClick = (route) => {
    if (role === ROLE.ADMIN) {
      navigate(`/auth/admin/${route}`);
    } else if (role === ROLE.USER) {
      navigate(`/auth/user/${route}`);
    }
  };

  const handleSetRead = (id) => {
    readNotification(id).then((res) => console.log(res, "res"));
  };

  const handleSetReadAdmin = (id) => {
    readNotificationAdmin(id).then((res) => console.log(res, "res"));
  };

  return (
    <div>
      <div className="flex justify-between items-center">
        <h3 className="p-2 m-1" style={{ color: primaryColor }}>
          Centro notifiche
        </h3>
        {/* <Tooltip title="Elimina tutte le notifiche">
          <IconButton
            disabled={lists.length === 0}
            className="mx-2"
            onClick={() => dispatch(actions.clearNotifications(lists))}
          >
            <DeleteOutlineRoundedIcon className="text-red-600" />
          </IconButton>
        </Tooltip> */}
      </div>
      <Divider />
      {lists?.map((el) => {
        const { icon, label, route } =
          role === ROLE.USER
            ? typeNotificationIconUser(el.type, role)
            : typeNotificationIcon(el.type, role);

        return (
          <MenuItem
            key={el.id}
            className="w-min-60 flex space-x-2"
            onClick={() => {
              handleRouteClick(route);
              if (role === ROLE.USER) handleSetRead(el.id);
              if (role !== ROLE.USER) handleSetReadAdmin(el.id);
              setAnchorElNotifiche(null);
            }}
          >
            {!el.read && <CircleRoundedIcon className="w-2 h-2 text-red-600" />}
            <div style={{ fontWeight: el.read ? "normal" : "bold" }}>
              <div className="flex items-center space-x-2">
                {icon}
                <p className="text-sm">{label}</p>
              </div>
            </div>
            <Divider />
          </MenuItem>
        );
      })}
      {lists.length === 0 && (
        <p className="text-gray text-center px-8">Nessuna notifica</p>
      )}
    </div>
  );
};

export default ListsNotification;
